
namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    export class PsMemberGenderGrid extends Serenity.EntityGrid<PsMemberGenderRow, any> {
        protected getColumnsKey() { return PsMemberGenderColumns.columnsKey; }
        protected getDialogType() { return PsMemberGenderDialog; }
        protected getIdProperty() { return PsMemberGenderRow.idProperty; }
        protected getInsertPermission() { return PsMemberGenderRow.insertPermission; }
        protected getLocalTextPrefix() { return PsMemberGenderRow.localTextPrefix; }
        protected getService() { return PsMemberGenderService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}